export const REGISTRATION_ACTION = 'REGISTRATION_ACTION';
export const REGISTRATION_SUCCESS_ACTION = 'REGISTRATION_SUCCESS_ACTION';
export const REGISTRATION_FAILURE_ACTION = 'REGISTRATION_FAILURE_ACTION';
